var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStrokeQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.504883,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#046C9C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15.7049C9.18412 15.7049 7.30003 13.8208 7.30003 11.5049C7.30003 9.18903 9.18412 7.30502 11.5 7.30502C13.8158 7.30502 15.7 9.18903 15.7 11.5049C15.7 12.1526 15.5525 12.7663 15.2896 13.3145L14.507 12.532C13.9602 11.9853 13.0738 11.9853 12.527 12.532C11.9803 13.0788 11.9803 13.9652 12.527 14.5119L13.3096 15.2945C12.7613 15.5574 12.1476 15.7049 11.5 15.7049ZM17.3378 15.3629C18.0718 14.256 18.5 12.9296 18.5 11.5049C18.5 7.64517 15.3599 4.50498 11.5 4.50498C7.64019 4.50498 4.5 7.64517 4.5 11.5049C4.5 15.3648 7.64019 18.5049 11.5 18.5049C12.9247 18.5049 14.251 18.0767 15.3579 17.3428L16.11 18.0949C16.3834 18.3682 16.7417 18.5049 17.1 18.5049C17.4582 18.5049 17.8166 18.3682 18.0899 18.0949C18.6366 17.5482 18.6366 16.6617 18.0899 16.1149L17.3378 15.3629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStrokeQuestion);
export default __webpack_public_path__ + "static/media/icon-stroke-question.dc97e957e621fd4961ebd50f58824ba1.svg";
export { ForwardRef as ReactComponent };